module.exports = fox._r("images/promo/tutorial/19.png", __webpack_public_path__ + "_/common/images/promo/tutorial/19.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/19.png
// module id = 664
// module chunks = 2